import enumeration from "../../enums/enumeration";

const TrackEvent = {
  VisitedPage: "Visited Page",
  ClickedButton: "Clicked Button",
};

export default enumeration(TrackEvent);
